<template>
  <div class="fenxiao-bill">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2 class="page-title">佣金记录</h2>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
    </div>

    <!-- 账单列表 -->
    <div v-else class="bill-list-container">
      <div v-if="accountList.length > 0" class="bill-list">
        <div 
          v-for="item in accountList" 
          :key="item.id"
          class="bill-item"
        >
          <!-- 账单图标 -->
          <div class="bill-icon">
            <img 
              v-if="item.type == 'order'" 
              :src="$util.img('upload/uniapp/fenxiao/bill/jiesuan.png')" 
              alt="结算"
            />
            <img 
              v-else 
              :src="$util.img('upload/uniapp/fenxiao/bill/withdraw.png')" 
              alt="提现"
            />
          </div>

          <!-- 账单信息 -->
          <div class="bill-info">
            <div class="bill-type">{{ item.type_name || '-' }}</div>
            <div class="bill-no">账单编号: {{ item.account_no || '-' }}</div>
            <div class="bill-time">{{ formatTime(item.create_time) }}</div>
          </div>

          <!-- 金额 -->
          <div class="bill-amount">
            <span :class="['amount-text', item.money > 0 ? 'positive' : 'negative']">
              {{ item.money > 0 ? '+' + item.money : item.money }}
            </span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else-if="showEmpty" class="empty-container">
        <div class="empty-content">
          <i class="el-icon-document"></i>
          <p>暂无账单信息</p>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div v-if="accountList.length > 0" class="pagination-container">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next, jumper"
        background
      />
    </div>
  </div>
</template>

<script>
import { getFenxiaoBillList } from '@/api/fenxiao'

export default {
  name: 'FenxiaoBill',
  data() {
    return {
      loading: false,
      accountList: [],
      showEmpty: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getBillData()
  },
  methods: {
    // 获取账单数据
    getBillData() {
      this.loading = true
      this.showEmpty = false
      
      getFenxiaoBillList({
        page: this.currentPage,
        page_size: this.pageSize
      }).then(res => {
        this.loading = false
        this.showEmpty = true
        
        if (res.code === 0 && res.data) {
          this.accountList = res.data.list || []
          this.total = res.data.count || 0
        } else {
          this.accountList = []
          this.total = 0
          this.$message.error(res.message || '获取账单数据失败')
        }
      }).catch(error => {
        this.loading = false
        this.showEmpty = true
        this.accountList = []
        this.total = 0
        console.error('获取账单数据失败:', error)
        this.$message.error('获取账单数据失败')
      })
    },

    // 分页切换
    handlePageChange(page) {
      this.currentPage = page
      this.getBillData()
    },

    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fenxiao-bill {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 60px);

  .page-header {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .page-title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    background: #fff;
    border-radius: 8px;

    .loading-spinner {
      display: flex;
      align-items: center;
      color: #666;

      i {
        font-size: 20px;
        margin-right: 8px;
      }
    }
  }

  .bill-list-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .bill-list {
      .bill-item {
        display: flex;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #f0f0f0;
        transition: background-color 0.3s;

        &:hover {
          background-color: #f9f9f9;
        }

        &:last-child {
          border-bottom: none;
        }

        .bill-icon {
          width: 50px;
          height: 50px;
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .bill-info {
          flex: 1;
          display: flex;
          flex-direction: column;

          .bill-type {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 5px;
          }

          .bill-no {
            font-size: 14px;
            color: #666;
            margin-bottom: 5px;
          }

          .bill-time {
            font-size: 12px;
            color: #999;
          }
        }

        .bill-amount {
          .amount-text {
            font-size: 18px;
            font-weight: 600;

            &.positive {
              color: #67c23a;
            }

            &.negative {
              color: #f56c6c;
            }
          }
        }
      }
    }

    .empty-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;

      .empty-content {
        text-align: center;
        color: #999;

        i {
          font-size: 48px;
          margin-bottom: 16px;
          display: block;
        }

        p {
          margin: 0;
          font-size: 16px;
        }
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}
</style>